import React from 'react';
import { sdcDesignationTitleColumnsList } from '../../constants/MockData';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import { isGridFormValid, IsSectionVisible, UpdateColumnWithConfiguration, getCurrentPayCycleStartDate } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';
import moment from 'moment';
import store from '../../store/appStore';

export default class ConfigureSdcEmployeeDesignationPmaTitle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirmMessage: null,
      showWarningMessage: false,
      isSplit: false,
      designationMasterData: [],
      // pmaTitleMasterData: [],
      sdcDesignationTitleData: [],
      sdcMasterPMATitles: [],
      isInAddMode: false,
      isDelete: false,
      configuration: [],
      selectedEditRowId: undefined,
      isEditEnable: true,
      validationMessage: [],
      isStartDateSame: false,
      updateData: {
        parentRecordId: 0,
        splitDesignation: false,
        pmaTitleId: 0,
        pmaTitle: '',
        startDate: moment().format('YYYY/MM/DD'),
        endDate: undefined,
        designationId: null,
        designation: undefined,
        flag: false,
        createdBy: '',
        createdDate: moment().format('YYYY/MM/DD'),
        statusId: 0,
        modifiedBy: '',
        modifiedDate: moment().format('YYYY/MM/DD')
      },
      sdcDesignationTitleColumns: _.cloneDeep(sdcDesignationTitleColumnsList)
    };
  }

  componentDidMount() {
    this.getRequiredData();
  }

  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      // {
      //   url: API_URL.Employee.GetDesignationMasterData,
      //   key: 'designationMasterData'
      // },
      {
        url: API_URL.Users.GetSDCDesignationTitleConfiguration,
        key: 'sdcDesignationTitleData'
      }
      // {
      //     url: API_URL.Users.GetPmaTitles,
      //     key: 'pmaTitleMasterData'
      // }
    ])
      .then(({ sdcDesignationTitleData }) => {
        this._asyncRequest = null;
        if (sdcDesignationTitleData.success !== true) {
          ShowToast(
            'Something went wrong',
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const titleData = _.cloneDeep(sdcDesignationTitleData.data || []);
        this.setState({
          // designationMasterData: designationMasterData.data || [],
          // pmaTitleMasterData: pmaTitleMasterData.data || [],
          sdcDesignationTitleData: (titleData || []).map(x => {
            if (x.pmaTitleId === x.parentPmaTitleId) {
              x.parentPmaTitle = '-';
            }
            return x;
          }),
          configuration: sdcDesignationTitleData.config || [],
          sdcMasterPMATitles: _.cloneDeep((sdcDesignationTitleData.data || []).filter(x => x.pmaTitleId === x.parentPmaTitleId))
          // reloadTable: !this.state.reloadTable
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const sdcDesignationTitleColumns = _.cloneDeep(sdcDesignationTitleColumnsList);
    const currentPaycycleStartDate = getCurrentPayCycleStartDate();
    const rowNew = {
      // designationPMATitleId: 0,
      parentRecordId: 0,
      splitDesignation: false,
      pmaTitleId: 0,
      pmaTitle: '',
      parentPmaTitleId: 0,
      startDate: currentPaycycleStartDate, // moment().format('YYYY/MM/DD'),
      endDate: undefined,
      designationId: null,
      designation: undefined,
      flag: false,
      createdBy: '',
      createdDate: moment().format('YYYY/MM/DD'),
      statusId: 0,
      modifiedBy: '',
      modifiedDate: moment().format('YYYY/MM/DD')
    };

    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: 'pmaTitleId', value: 0 },
      reloadTable: !this.state.reloadTable,
      updateData: rowNew,
      sdcDesignationTitleColumns
    });
  };

  /**
   * cancel row open for add mode
   */
  cancelAddMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !this.state.relaodTable
    });
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !this.state.relaodTable
    });
  };

  /**
   * returns start date
   * @returns
   */
  getStartDate() {
    let stDate = (this.state.sdcDesignationTitleData || []).filter(
      (x) => x.pmaTitleId === this.state.updateData.pmaTitleId
    );
    if (stDate.length > 0 && stDate !== undefined && stDate !== null) {
      stDate = stDate[0].startDate;
      return stDate;
    } else {
      return null;
    }
  }

  IsDesignationExistsWithDifferentTitle(ele) {
    const existingDepartmentId = ele.designationId.split('|');
    const newDepartmentId = this.state.updateData.designationId.split('|');
    let matchedDepartment = null;
    if (ele.pmaTitleId !== this.state.updateData.pmaTitleId) {
      matchedDepartment = existingDepartmentId.filter((m) =>
        newDepartmentId.some((n) => m === n)
      );
    }

    return matchedDepartment;
  }

  checkAtleastOnePresent = () => {
    let isExists = false;
    const activeRecord = this.state.sdcDesignationTitleData.filter(x =>
    (x.endDate === null ||
      x.endDate === '0001-01-01T00:00:00' || moment(x.endDate).format(DateFormat) >= moment(this.state.updateData.startDate).format(DateFormat))
    );
    if (activeRecord?.length > 0) {
      activeRecord.forEach((ele) => {
        const matchedDepartment = this.IsDesignationExistsWithDifferentTitle(ele);
        if (isExists === false && matchedDepartment?.length > 0) {
          isExists = true;
        }
      });
    }
    return isExists;
  }

  isDateInSamePayCycle(stdate, date) {
    let isValid = false;
    const currentMonthStartDate = moment(date).startOf('month').format('YYYY/MM/DD');
    const currentMonthMidDate = moment(currentMonthStartDate, 'YYYY/MM/DD').add(14, 'days');
    const currentMonthLastDate = moment(date).endOf('month').format('YYYY/MM/DD');

    if (((date >= currentMonthStartDate && date <= currentMonthMidDate.format('YYYY/MM/DD')) &&
      (stdate >= currentMonthStartDate && stdate <= currentMonthMidDate.format('YYYY/MM/DD'))) || (
        (date >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') && date <= currentMonthLastDate) &&
        (stdate >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') && stdate <= currentMonthLastDate))) { isValid = true; } else { isValid = false; }
    return isValid;
  }

  /**
  * check if designation is present in title master data
  * @param {*} ele
  * @returns
  */
  isDesignationPresent(ele) {
    const existingDepartmentId = ele.designationId.split('|');
    const newDepartmentId = this.state.updateData.designationId.split('|');

    const matchedDepartment = existingDepartmentId.filter((m) =>
      newDepartmentId.some((n) => m === n)
    );
    return matchedDepartment;
  }

  isDesignationExistInTitleGroup() {
    let newParam = [];
    let isValid = false;
    let isStartDateSame = false;
    let isNewParamValid = false;
    newParam = this.state.updateData;
    let filterTitleData = '';
    let breakCondition = false;

    this.state.sdcDesignationTitleData.forEach((ele) => {
      if (ele.pmaTitleId !== this.state.updateData.pmaTitleId && ele.endDate !== null &&
        !breakCondition && ele.endDate !== '0001-01-01T00:00:00' &&
        this.state.updateData.startDate >= moment(ele.startDate).format('YYYY/MM/DD') && this.state.updateData.startDate <= moment(ele.endDate).format('YYYY/MM/DD')) {
        const matchedDepartment = this.isDesignationPresent(ele);
        if (matchedDepartment.length > 0) {
          breakCondition = true;
          newParam = null;
          isValid = true;
        }
      }
    }
    );

    if (!isValid) {
      this.state.sdcDesignationTitleData.forEach((ele) => {
        if (ele.pmaTitleId !== this.state.updateData.pmaTitleId &&
          !breakCondition && ele.endDate !== null &&
          ele.endDate === '0001-01-01T00:00:00'
          // && this.isDateInSamePayCycle(moment(ele.startDate).format("YYYY-MM-DD"),this.state.updateData.startDate)          
        ) {
          const matchedDepartment = this.isDesignationPresent(ele);
          if (matchedDepartment.length > 0) {
            if (ele.designationId === this.state.updateData.designationId) {
              isNewParamValid = true;
            } else if (moment(ele.startDate).format('YYYY/MM/DD') >= this.state.updateData.startDate ||
              this.isDateInSamePayCycle(moment(ele.startDate).format('YYYY/MM/DD'), this.state.updateData.startDate)
            ) {
              isStartDateSame = true;
            }
            filterTitleData = ele;
            breakCondition = true;
          }
          // return;
        }
      });
      if (isStartDateSame) {
        newParam = false;
      } else if (isNewParamValid) {
        newParam = true;
      } else if (filterTitleData !== null && filterTitleData !== undefined) {
        newParam.parentRecordId = filterTitleData.pmaTitleId;

        this.setState({
          updateData: newParam
        });
      }
    }

    return newParam;
  }

  /**
       * is Form Valid
       */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, sdcDesignationTitleColumns } = this.state;
    sdcDesignationTitleColumns.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ sdcDesignationTitleColumns }, this.forceUpdate());
    return IsValid;
  };

  saveUpdatedRecord = () => {
    if (!this.isValidForm()) {
      return false;
    } else {
      const { updateData, sdcDesignationTitleData } = this.state;
      let saveRecord = true;
      sdcDesignationTitleData.every((ele) => {
        if (ele.pmaTitleId !== updateData.pmaTitleId && ele.pmaTitle.trim().toLowerCase() === updateData.pmaTitle.trim().toLowerCase()) {
          ShowToast('PMA title with same name already exists.', toastType.ERROR, 5000, 5000);
          saveRecord = false;
          return false;
        } else if (ele.pmaTitleId === updateData.pmaTitleId &&
          ele.pmaTitle.trim().toLowerCase() === updateData.pmaTitle.trim().toLowerCase() &&
          ele.parentPmaTitleId === updateData.parentPmaTitleId
        ) {
          ShowToast('Changes are not found. Please make changes to update record.', toastType.ERROR, 5000, 5000);
          saveRecord = false;
          return false;
        }
        return true;
      });
      if (saveRecord === true) {
        this.saveRecord(updateData);
      }
    }
  };

  saveUpdatedRecord1 = () => {
    if (!this.isValidForm()) { return false; } else {
      let newParam = [];
      let isValid = false;
      const currentPaycycleStartDate = getCurrentPayCycleStartDate();
      const currentMonthStartDate = moment().startOf('month').format('YYYY/MM/DD');
      const currentMonthMidDate = moment(currentMonthStartDate, 'YYYY/MM/DD').add(14, 'days');
      newParam = this.isDesignationExistInTitleGroup();

      if (newParam === null) {
        ShowToast('Record with same designation already present for same date.', toastType.ERROR, 5000, 5000);
        return false;
      } else if (newParam === false) {
        // this.setState({
        //   isStartDateSame : false
        // }, ()=>{ this.forceUpdate();})
        ShowToast(
          'Please select either different date or update same record . It seems record with either same date or greater is already present.',
          toastType.ERROR,
          5000,
          5000
        );
      } else if (newParam === true) {
        ShowToast(
          'Record already present .Please modify existing record.',
          toastType.ERROR,
          5000,
          5000
        );
      } else if (this.checkAtleastOnePresent() === true) {
        ShowToast(
          'At least one designation is present in other group. Please edit or remove designation from that group.',
          toastType.ERROR,
          5000,
          5000
        );
      } else {
        if (!this.state.isInAddMode) {
          // if (moment(this.state.updateData.startDate).format('YYYY/MM/DD') < moment().format('YYYY/MM/DD')) {
          if (moment(this.state.updateData.startDate).format('YYYY/MM/DD') < currentPaycycleStartDate.format('YYYY/MM/DD')) {
            ShowToast('Application start date should be current paycycle or future date.', toastType.ERROR, 5000, 5000);
            return false;
          }
        }
        const stDate = this.getStartDate();

        if (this.state.isInAddMode) {
          newParam.flag = false;
        } else {
          newParam = this.state.updateData;
          if (this.isDateInCurrentPayCycle(stDate) || this.isDateInNextPayCycle(stDate)) { isValid = true; }
          if (isValid) {
            newParam.flag = false;
          } else {
            newParam.flag = true;
          }
        }

        // check if start date is valid for update record
        if (
          stDate !== null &&
          stDate !== undefined &&
          stDate !== null &&
          (moment(stDate).format('YYYY/MM/DD') === moment(newParam.startDate).format('YYYY/MM/DD') ||
            // moment(newParam.startDate).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD')
            moment(newParam.startDate).format('YYYY/MM/DD') >= currentPaycycleStartDate.format('YYYY/MM/DD')
          )
        ) {
          if (
            newParam.parentRecordId !== undefined &&
            newParam.parentRecordId !== 0
          ) {
            this.setState({
              confirmMessage: 'Record with similar designation already present.Do you want to split?',
              showWarningMessage: true,
              updateData: newParam,
              reloadTable: !this.state.reloadTable
            });
            this.forceUpdate();
          } else this.saveRecord(newParam);
        }
        // check if start date is valid for new record
        else if (
          stDate === null &&
          // moment(newParam.startDate).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD')
          moment(newParam.startDate).format('YYYY/MM/DD') >= currentPaycycleStartDate.format('YYYY/MM/DD')
        ) {
          if (
            newParam.parentRecordId !== undefined &&
            newParam.parentRecordId !== 0
          ) {
            this.setState({
              confirmMessage: 'Record with similar designation already present.Do you want to split?',
              showWarningMessage: true,
              updateData: newParam
            });
            this.forceUpdate();
          } else this.saveRecord(newParam);
        } else {
          ShowToast('Applicable From date should be current paycycle or future date', toastType.ERROR, 5000, 5000);
          return false;
        }
      }
    }
  };

  /**
   * check if given date is in current pay cycle
   * @param {*} date
   * @returns bool
   */
  isDateInCurrentPayCycle(date) {
    let isValid = false;
    const currentMonthStartDate = moment()
      .startOf('month')
      .format('YYYY/MM/DD');
    const currentMonthMidDate = moment(currentMonthStartDate, 'YYYY/MM/DD').add(
      14,
      'days'
    );
    const currentMonthLastDate = moment().endOf('month').format('YYYY/MM/DD');
    if (
      (moment(date).format('YYYY/MM/DD') >= moment(currentMonthStartDate).format('YYYY/MM/DD') &&
        moment(date).format('YYYY/MM/DD') <= currentMonthMidDate.format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') >= moment(currentMonthStartDate).format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') <= currentMonthMidDate.format('YYYY/MM/DD')
      ) ||
      (moment(date).format('YYYY/MM/DD') >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') &&
        moment(date).format('YYYY/MM/DD') <= moment(currentMonthLastDate).format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') <= moment(currentMonthLastDate).format('YYYY/MM/DD')
      )
    ) { isValid = true; } else isValid = false;
    return isValid;
  }

  /**
   * check if given date is in next pay cycle
   * @param {*} date
   * @returns bool
   */
  isDateInNextPayCycle(date) {
    let isNext = false;
    isNext = this.isDateInCurrentPayCycle(date);
    if (isNext === false && moment(date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD')) { isNext = true; } else { isNext = false; }
    return isNext;
  }

  isArrayEquals = (a, b) => {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (let i = 0; i < a.length; ++i) {
      if (b.find(x => parseInt(x) === parseInt(b[i])) === undefined) return false;
    }
    return true;
  }

  isEditIconVisible = (cellInfo) => {
    const { sdcDesignationTitleData } = this.state;
    if (IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_DESIGNATION_PMA_TITLE, SECTIONS.ADD_EDIT)) {
      const titleData = sdcDesignationTitleData.filter(x => x.pmaTitle === cellInfo.pmaTitle && this.isArrayEquals(x.designationId.split('|'), cellInfo.designationId.split('|')));
      // console.log(titleData);
      if (cellInfo !== undefined &&
        (cellInfo.endDate === null ||
          cellInfo.endDate === '0001-01-01T00:00:00' || moment(cellInfo.endDate).format(DateFormat) > moment().format(DateFormat))) {
        return true;
      }
      if ((titleData || []).length > 1) {
        const latest = titleData.reduce(function (r, a) {
          return moment(r.startDate).format(DateFormat) > moment(a.startDate).format(DateFormat) ? r : a;
        });
        if (latest.pmaTitleId !== cellInfo.pmaTitleId) {
          return false;
        }
      }
    }
    return false;
  }

  EditRecord = (cellInfo) => {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      const sdcDesignationTitleColumns = _.cloneDeep(sdcDesignationTitleColumnsList);
      sdcDesignationTitleColumns.forEach(x => {
        if (x.key === 'parentPmaTitle' && cellInfo.parentPmaTitleId === cellInfo.pmaTitleId) {
          x.disabled = true;
        }
      });
      cellInfo.isDelete = false;
      this.setState({
        selectedEditRowId: {
          key: 'pmaTitleId',
          value: cellInfo.pmaTitleId
        },
        isInAddMode: false,
        updateData: { ...cellInfo },
        reloadTable: !this.state.relaodTable,
        sdcDesignationTitleColumns
      });
    }
  }

  deleteRecord(cellInfo) {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      this.setState({
        isDelete: true,
        showWarningMessage: true,
        confirmMessage: 'Do you want to delete this record ?',
        updateData: cellInfo
      });
    }
  };

  renderActionColumn = (cellInfo, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.pmaTitleId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.saveUpdatedRecord}
                >
                  <SaveIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={isInAddMode ? this.cancelAddMode : this.cancelEditMode}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>

            </>
          )
          : <> {
            this.isEditIconVisible(cellInfo) && (
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            )
          }
            { (IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_DESIGNATION_PMA_TITLE, SECTIONS.ADD_EDIT))
              ? (
                <Tooltip title="Delete">
                  <IconButton aria-label={'refreshData'} size="small" onClick={() => {
                    this.deleteRecord(cellInfo);
                  }}
                  >
                    <DeleteIcon fontSize="small" size="small" />
                  </IconButton>
                </Tooltip>
              )
              : null}
          </>
        }

      </>
    );
  };

  /**
   * handle on change
   * @param {*} value
   * @param {*} fieldName
   */
  handleTableEditChange = (value, fieldName) => {
    const designationData = this.state.designationMasterData;
    const param = this.state.updateData;
    const { sdcDesignationTitleColumns, sdcMasterPMATitles } = this.state;
    const validationMessage = this.state.validationMessage;
    if (fieldName === 'designation') {
      const valueOfDesignation = [];
      value.forEach((val) => {
        designationData.find((x) => x.designation === val) &&
          valueOfDesignation.push(
            designationData.find((x) => x.designation === val).designationID
          );
      });
      param.designationId = valueOfDesignation.join('|');
      param[fieldName] = value.join('|');
    } else if (fieldName === 'pmaTitle') {
      param[fieldName] = value || '';
      // this.validateField(fieldName, 'BurdenRate is required.');
    } else if (fieldName === 'parentPmaTitle') {
      const pmaData = sdcMasterPMATitles.find((x) => x.parentPmaTitle === value);
      param.parentPmaTitleId = (pmaData || {}).pmaTitleId;
      param[fieldName] = value;
    } else if (fieldName === 'startDate') {
      param[fieldName] = value || [];
    } else if (fieldName === 'endDate') {
      param[fieldName] = value || [];
    } else {
      param[fieldName] = value;
    }

    param.cloudOrgId = param.cloudOrgId === undefined ? 1 : param.cloudOrgId;
    param.userEmail =
      param.userEmail === undefined
        ? (((store.getState() || {}).auth || {}).account || {}).username
        : param.userEmail;

    isGridFormValid(value, sdcDesignationTitleColumns.find(x => x.key === fieldName), param);

    this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) });

    this.forceUpdate();
  };

  /**
   * save record into database table
   * @param {*} newParam
   * @returns
   */
  saveRecord(newParam) {
    if (newParam !== null && newParam.startDate !== null && typeof newParam.startDate === 'object') {
      newParam.startDate = newParam.startDate.format('YYYY/MM/DD');
    }
    if ((this.state.validationMessage || []).length > 0) { return false; }
    apiPost({
      url: API_URL.Users.UpdateSDCDesignationTitleConfiguration,
      postBody: newParam
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(
          this.state.isInAddMode
            ? 'Record added successfully.'
            : 'Record updated successfully.',
          toastType.SUCCESS,
          5000,
          500
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          showWarningMessage: false,
          isInAddMode: false
        });
        this.getRequiredData();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  }

  /**
   * handle on delete
   * @param {*} e
   */
  onDeleteHandel(e) {
    const newParam = this.state.updateData;
    if (e) {
      // newParam.startDate = null;// '0001-01-01'
      newParam.isDelete = true;
      this.setState({
        updateData: newParam,
        isDelete: false,
        showWarningMessage: false
      });
      this.saveRecord(newParam);
    } else {
      newParam.isDelete = false;
      this.setState({ showWarningMessage: false, confirmationMessage: '', updateData: newParam });
    }
  }

  /**
   * handle dialog box click event
   * @param {*} e
   */
  onClickHandel(e) {
    if (this.state.isDelete) {
      this.onDeleteHandel(e);
    } else {
      this.setState({
        showWarningMessage: false
      });
      let newParam = [];
      newParam = this.state.updateData;
      newParam.splitDesignation = e;
      if (e) this.saveRecord(newParam);
    }
  }

  render() {
    const { designationMasterData, pmaTitleMasterData, configuration, sdcDesignationTitleColumns, sdcMasterPMATitles } = this.state;

    const EditSource = [];
    // EditSource.push({
    //   key: 'designationMasterData',
    //   data: designationMasterData
    // });
    EditSource.push({
      key: 'sdcMasterPMATitles',
      data: sdcMasterPMATitles
    });

    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Configure Datacenter PMA Title
                                    </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  validationMessage={this.state.validationMessage || []}
                  columns={UpdateColumnWithConfiguration(
                    sdcDesignationTitleColumns,
                    configuration,
                    []
                  )}
                  data={this.state.sdcDesignationTitleData}
                  isInline={true}
                  config={sdcDesignationTitleColumns}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  AddNewRecord={{
                    action: this.AddNewRecord,
                    title: 'Add New Datacenter PMA Title',
                    visible: IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_DESIGNATION_PMA_TITLE, SECTIONS.ADD_EDIT)
                  }}
                  reload={this.state.reloadTable}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
